import React from 'react';
import BaseTooltip from 'react-portal-tooltip';

import TooltipButtons from './components/TooltipButtons';
import TooltipDescription from './components/TooltipDescription';
import TooltipImage from './components/TooltipImage';
import { DEFAULT_TIMEOUT, TOOLTIP_STYLE } from 'components/Tooltip/constants';
import { IQuality } from 'types/qualities';

interface Props {
  active: boolean,
  data: Partial<IQuality> & { buttons?: any[], secondaryDescription?: string },
  parent?: HTMLElement | null,
  tooltipPos?: any,
  tooltipTimeout?: number | string,
}

export default function Tooltip(props: Props) {
  const {
    active,
    data,
    parent,
    tooltipPos,
    tooltipTimeout,
  } = props;

  // The Tooltip library appears to render before the elements, this stops it doing so.
  if (!parent) {
    return null;
  }

  if (!parent.getBoundingClientRect) {
    console.info('Trying to attach a tooltip to a parent with no bounding client rect.');
    console.info(parent);
  }

  const {
    image,
    nature,
    buttons,
    useEventId,
  } = data;

  const position = tooltipPos || 'bottom';
  const timeout = tooltipTimeout !== undefined ? parseInt(tooltipTimeout.toString(), 10) : DEFAULT_TIMEOUT;

  return (
    <BaseTooltip
      active={active}
      position={position}
      parent={parent}
      tooltipTimeout={timeout}
      useHover={!!useEventId}
      style={TOOLTIP_STYLE}
    >
      <div className="tooltip">

        {image && <TooltipImage image={image} nature={nature} />}
        <div className={image ? 'tooltip__desc' : 'tooltip__desc__noImage'}>
          <TooltipDescription {...data} />
          {buttons && <TooltipButtons buttons={buttons} />}
        </div>
      </div>
    </BaseTooltip>
  );
}

Tooltip.displayName = 'Tooltip';
